import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fullscreenCenteredContainer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "subtitle" }, "Please wait...", -1)

import { reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
import { validatePasswordReset, applyPasswordReset } from "@/core/session"
import { notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { Validations } from "@/composables/useValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordReset',
  setup(__props) {

const instance = getCurrentInstance();

const username = useRoute().query.username?.toString();
const token = useRoute().query.token?.toString();
const isNewAccount = useRoute().query.isNewAccount?.toString();

const proceedToLogin = () => {
  instance!.proxy!.$router.push("/");
};

if (!username || !token) {
  notifyError("Invalid password reset URL");
  proceedToLogin();
}

const passwordResetState = reactive({
  inProgress: false,
  password: "",
  repeatPassword: ""
});

const resetPassword = () => {
  if (!(Validations.notEmpty(passwordResetState.password) && passwordResetState.password.length >= 8 && passwordResetState.password == passwordResetState.repeatPassword)) {
    notifyError("Please make sure the passwords match, and are at least 8 characters long");
    return;
  }
  passwordResetState.inProgress = true;
  
  applyPasswordReset(username!, token!, passwordResetState.password)
  .then(() => {
    notifySuccess("Password reset successfully!");
    proceedToLogin();
  })
  .catch(() => {
    notifyError("Password reset failed");
    passwordResetState.inProgress = false;
  });
};

onMounted(() => {
  passwordResetState.inProgress = true;
  
  validatePasswordReset(username!, token!)
  .then((isValid) => {
    if (isValid) {
      passwordResetState.inProgress = false;
    } else {
      notifyError("Invalid or expired password reset link");
      proceedToLogin();
    }
  })
  .catch((err) => notifyNetworkError("Failed to verify password reset link", err));
})

return (_ctx: any,_cache: any) => {
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (passwordResetState.inProgress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_LoadingSpinner, {
            size: "large",
            style: {"margin-bottom":"10px"}
          }),
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalDialog, {
      active: !passwordResetState.inProgress,
      title: _unref(isNewAccount)=='true' ? 'Choose Your Password' : 'Reset Password',
      "first-button-text": _unref(isNewAccount)=='true' ? 'Set Password' : 'Reset Password',
      "first-button-severity": "primary",
      onFirstbuttonselected: _cache[2] || (_cache[2] = ($event: any) => (resetPassword()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_FormTextField, {
            label: "Please enter your new password",
            placeholder: "Password",
            isPassword: true,
            modelValue: passwordResetState.password,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((passwordResetState.password) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_FormTextField, {
            label: "Repeat Password",
            placeholder: "Repeat Password",
            isPassword: true,
            modelValue: passwordResetState.repeatPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordResetState.repeatPassword) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["active", "title", "first-button-text"])
  ], 64))
}
}

})